export const gitCommit = 'f89d6eaa'
